import React from 'react';
import { observer, inject } from 'mobx-react';
import Player from 'react-player';

import {
  Container,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';

import HomePlayer from './HomePlayer';
import AvatarQuote from './HomeAvatarQuote';
import ReadAboutAndVideos from './HomeReadAboutAndVideos';
import Features from './HomeFeatures';

@inject('appState')
@observer
class Home extends React.Component {
  render() {
    const {
      modalPlayerVideo,
      modalIsOpen,
      toggleModal
    } = this.props.appState;

    return (
      <div className="home">
        <HomePlayer />
        <Container className="mt-5">
          <AvatarQuote />
          <ReadAboutAndVideos />
          <Features />
        </Container>
        <Modal isOpen={modalIsOpen} toggle={toggleModal} size="lg">
          <ModalHeader toggle={this.props.appState.toggleModal}>
            {modalPlayerVideo.title}
          </ModalHeader>
          <ModalBody>
            <Player
              url={modalPlayerVideo.url}
              playing={this.props.appState.modalIsPlaying}
              controls={true}
              className="embed-responsive embed-responsive-16by9"
              height="85%"
              width="90%"
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js